require('./formInput.scss');
require('./formInput.override.scss')

//@vendor
const React = require('react');
const PropTypes = require('prop-types');

//@core
const { FormattedText, getLanguage, formatText } = require('core/i18n').i18n;

//@utilities
const { toFirstUppercase } = require('utilities/stringHelper');

//@helpers
const { getFormattedString } = require('utilities/currencyHelper');

//@constants
const { EURO_SYMBOL, EURO_TEXT } = require('constants/index');

//@commons
const { AmountInput } = require('commonsComponents/amountInput');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

const FormInput = ({
    title,
    subtitle,
    minValue,
    maxValue,
    tooltipLabel,
    value,
    tooltipContent,
    handleAmountChange,
    disabled,
    plansDisableStatus,
    minValueLabel,
    zeroIsAccepted }) => {

    const buildTooltip = () => {
        return (
            tooltipLabel &&
            <OKTooltip
                content={formatText(tooltipContent)}
                offset={[0, -15]}
            />
        );
    };

    const formatCurrency = amount => {
        return getFormattedString({
            amount: amount,
            currency: EURO_TEXT,
            decimalsLength: 0
        });
    };

    const buildRestrictedPlanDisclaimerPlans = () => {
        let textLengh = 0;
        const disclaimers = Object.keys(plansDisableStatus).map(plan => {
            const selectedPlan = toFirstUppercase(plan);
            const separator = textLengh > 0 ? ', ' : ''
            if (!plansDisableStatus[plan]) {
                textLengh++
                return (
                    <span key={plan}>{separator}<FormattedText value={`insuranceRequestHomeCC-insuranceRequestHomeCC_restrictedCoverageModal${selectedPlan}`} /></span>
                )
            }
        });
        return disclaimers
    }

    const buildRestrictedPlanDisclaimer = () => {
        return disabled && (
            <div className="form-input__restricted-plan-disclaimer">
                <FormattedText value={`insuranceRequestHomeCC-insuranceRequestHomeCC_restrictedCoverageModal`} />
                {buildRestrictedPlanDisclaimerPlans()}
            </div>
        )
    }

    const handleAmountChangeCallback = minValue !== 0 && handleAmountChange;
    const amount = disabled ? 0 : value;
    return (
        <div className="form-input__container">
            <h1 className="form-input__title">
                {!!title && <FormattedText value={title} />} {buildTooltip()}
            </h1>
            <div className="form-input__subtitle">
                <FormattedText value={subtitle} />
            </div>
            <div className="form-input__amount-input">
                <AmountInput
                    amount={amount}
                    onChange={zeroIsAccepted && handleAmountChange}
                    callback={handleAmountChangeCallback}
                    fluid
                    hideFocusZero
                    inlineUnit={EURO_SYMBOL}
                    language={getLanguage()}
                    min={minValue}
                    max={maxValue}
                    removeDecimals
                    showBlurZero
                    disabled={disabled}
                />
            </div>
            <div className="form-input__min-max-values">
                <FormattedText
                    value={'insuranceRequestHomeCC-insuranceRequestHomeCC_specialCoveragesModalMinMax'}
                    injectedStrings={[formatCurrency(minValueLabel || minValue), formatCurrency(maxValue)]} />

            </div>
            {buildRestrictedPlanDisclaimer()}
        </div>
    );
};

FormInput.propTypes = {
    handleAmountChange: PropTypes.func.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string.isRequired,
    minValueLabel: PropTypes.number,
    minValue: PropTypes.number.isRequired,
    maxValue: PropTypes.number.isRequired,
    tooltipLabel: PropTypes.bool,
    plansDisableStatus: PropTypes.object,
    tooltipContent: PropTypes.string,
    value: PropTypes.number.isRequired,
    disabled: PropTypes.bool,
    zeroIsAccepted: PropTypes.bool
};

FormInput.defaultProps = {
    tooltipLabel: true,
    tooltipContent: '',
    disabled: false,
    minValueLabel: 0,
    plansDisableStatus: {},
    zeroIsAccepted: false
};

module.exports = FormInput;
